$(document).ready(function () {
  $(".tab-section").hide();
  $(".tab-section:first").show();
  $(".cstm-name:first").addClass("main-tab-active");
  $(".cstm-name").click(function () {
    $(".cstm-name").removeClass("main-tab-active");
    $(this).addClass("main-tab-active");
    $(".tab-section").hide();
    var class_name = $(this).attr("attrname");
    $(`.${class_name}`).show();
  });

  $(".hot-spot-block").hide();
  $(".hot-spot-block.hot-spot-block.cotton-farming").show();
  // $('.map-image-wrapper:first').show();
  $(".cstm-maptab.show-on-desktop .map-tab:last").addClass("tab-active");
  $(".map-tab").click(function () {
    $(".map-tab").removeClass("tab-active");
    $(".hotspot-block-dot").show();
    $(this).addClass("tab-active");
    $(".hot-spot-block").hide();
    var class_name1 = $(this).attr("attrname");
    $(`.${class_name1}`).show();
  });

  $(".shop-the-look-dots a:first").addClass("active");
  if ($(window).width() <= 768) {
    $(".hot-spot-block.hot-spot-block.cotton-farming").hide();
    $(".hot-spot-block.hot-spot-block.garment-manufacturing").show();
    $(".cstm-maptab.show-on-desktop .map-tab:first").addClass("tab-active");
    $(".cstm-content-block.for-mobile").hide();
  }
 $(".shop-the-look-dots").on("click touchstart", function (e) {
    e.preventDefault();
    $("body").addClass("impact-page-popup-on-mobile");
    $(".custom-popup-main.pdp-mobile").addClass("cstm-show");

    var dotAttrname = $(this).attr("attrname");
    $(".cstm-content-block.for-mobile").hide();
    $('.cstm-content-block.for-mobile[attrname="' + dotAttrname + '"]').show();
    $(".shop-the-look-dots a").removeClass("dot-active");
    $(this).find(a).addClass("active");
  });
  $("body").on("click", ".impact-product-modal__close", function () {
    $(".custom-popup-main.pdp-mobile").removeClass("cstm-show");
    $("body").removeClass("impact-page-popup-on-mobile");
  });
});
